<template>
    <div class="wrap">
        <van-popup v-model="isShowSearch" position="bottom" :round="true" class="popup">
            <div class="content">
                <div class="item-wrap" v-for="item in arrSerarr" :key="item.id">
                    <div class="title">{{ item.group_name }}</div>
                    <div class="info-wrap">
                        <div class="item" :class="{'item-active': itx.check}" @click.stop="change(itx)"
                             v-for="itx in item.sub_list" :key="itx.id">{{ itx.label_name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-wrap">
                <div class="btn-reset" @click="reset">重置</div>
                <div class="search" @click="chilkFrom">筛选</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import oWarmJs from "@/js/hvac/dossier/warm.js"

export default {
    props: ['typeValue'],
    name: "index",
    data() {
        return {
            isShowSearch: false,
            arrSerarr: [],
        }
    },
    created() {
        this.getSearUserData(this.typeValue)
    },
    methods: {
        change(itx) {
            itx.check = !itx.check
        },
        reset() {
            this.arrSerarr.forEach(item => {
                item.sub_list.forEach(itx => {
                    itx.check = false
                })
            })
        },
        //搜索-用户日志
        getSearUserData(typeValue) {
            oWarmJs.getSearchUserLog({type_value: typeValue}).then(res => {
                res.data.data.result.forEach(it => {
                    it.sub_list.forEach(is => {
                        is.check = false;
                    })
                })
                this.arrSerarr = res.data.data.result
            })
        },
        chilkFrom() {
            let arr = [];
            this.arrSerarr.forEach(it => {
                it.sub_list.forEach(is => {
                    if (is.check) {
                        arr.push({group_key: it.group_key, label_value: is.label_value})
                    }
                })
            })
            this.$emit('chilkFrom', arr);
            this.isShowSearch = false;
        }
    }
}
</script>

<style scoped lang="scss">
.popup {
    height: 70%;

    .btn-wrap {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        padding-top: 20px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 24px;
        display: flex;
        line-height: 72px;
        text-align: center;
        justify-content: space-between;
        padding-bottom: env(safe-area-inset-bottom);
        background: #ffffff;
        box-shadow: -100px 0 100px #bed6ef;

        //&:before{
        //    content:"";
        //    position: absolute;
        //    width: 100%;
        //    height: 144px;
        //    background: linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 20.75%, #E6F0FF 88.96%);
        //    top: -144px;
        //    left: 0;
        //}
        .btn-reset {
            background: rgba(13, 83, 252, 0.1);
            border: 1px solid #0D53FC;
            border-radius: 16px;
            width: 240px;
            color: #0D53FC;
            height: 72px;
            margin-bottom: 20px;
        }

        .search {
            width: 424px;
            height: 72px;
            color: #ffffff;
            background: #0D53FC;
            border-radius: 16px;
            margin-bottom: 20px;
        }
    }
}

.content {
    box-sizing: border-box;
    padding: 80px 48px 180px 48px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .item-wrap {
        margin-bottom: 42px;

        .title {
            font-weight: 400;
            font-size: 24px;
        }

        .info-wrap {
            margin-top: 32px;
            display: flex;
            flex-wrap: wrap;

            .item {
                color: #666666;
                width: 200px;
                padding: 10px 0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-size: 24px;
                border-radius: 16px;
                border: 1px solid #DDDDDD;
                margin-bottom: 16px;
                margin-right: 16px;

                &:nth-child(3n) {
                    margin-right: 0px;
                }
            }

            .item-active {
                background: #E7EEFF;
                color: #0D53FC;
                border: none;
            }
        }
    }
}
</style>
